(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-automotive-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reduceMotionRequested() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // Lazily promote the poster image to a real, autoplaying video.
    // Skipped entirely when motion is reduced, and skipped on small
    // screens unless the merchant explicitly enabled mobile video.
    function upgradeVideos() {
      if (reduceMotionRequested()) return;

      var isSmallScreen = window.matchMedia('(max-width: 749px)').matches;

      document.querySelectorAll('[data-cinematic-hero].cinematic-hero--has-video').forEach(function (hero) {
        var allowMobile = hero.getAttribute('data-show-video-mobile') === 'true';
        if (isSmallScreen && !allowMobile) return;

        var template = hero.querySelector('[data-cinematic-hero-sources]');
        var poster = hero.querySelector('.cinematic-hero__poster:not(.cinematic-hero__poster--mobile)');
        if (!template || !poster || hero.querySelector('.cinematic-hero__video')) return;

        var video = document.createElement('video');
        video.className = 'cinematic-hero__video';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.autoplay = true;
        video.preload = 'metadata';
        video.setAttribute('aria-hidden', 'true');
        video.appendChild(template.content.cloneNode(true));

        video.addEventListener('loadeddata', function () {
          video.classList.add('is-loaded');
        });

        poster.insertAdjacentElement('afterend', video);

        // autoplay can be rejected by the browser in rare cases; fail
        // quietly and keep showing the poster image.
        var playResult = video.play();
        if (playResult && typeof playResult.catch === 'function') {
          playResult.catch(function () {});
        }
      });
    }

    // Subtle, capped parallax drift on the background media only.
    // Scroll-only, passive, rAF-throttled, and only touches elements
    // currently on screen.
    function initParallax() {
      if (reduceMotionRequested()) return;

      var heroes = Array.prototype.slice.call(
        document.querySelectorAll('[data-cinematic-hero][data-parallax="true"]')
      );
      if (!heroes.length) return;

      var ticking = false;

      function update() {
        ticking = false;
        var viewportHeight = window.innerHeight;

        heroes.forEach(function (hero) {
          var media = hero.querySelector('.cinematic-hero__media');
          if (!media) return;
          var rect = hero.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > viewportHeight) return;

          var drift = rect.top * 0.06;
          if (drift > 40) drift = 40;
          if (drift < -40) drift = -40;
          media.style.transform = 'translate3d(0, ' + drift.toFixed(1) + 'px, 0)';
        });
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    function init() {
      upgradeVideos();
      initParallax();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
